import { Loader } from "@logora/debate.progress.loader";
import React from "react";
import styles from "./Timeline.module.scss";
import { TimelineMilestone } from "./TimelineMilestone";

export const Timeline = ({
	milestones = [],
	selectedActeUid,
	onChangeActe,
}) => {
	const defaultLegislature = Math.max(
		...milestones
			.map((m) => m.acteLegislatif?.legislature)
			.filter((l) => l)
			.map(Number),
	).toString();

	const legislatures = milestones.reduce((acc, milestone) => {
		const key = milestone.acteLegislatif?.legislature
			? milestone.acteLegislatif?.legislature
			: defaultLegislature;
		if (!acc[key]) {
			acc[key] = [];
		}
		acc[key].push(milestone);
		return acc;
	}, {});

	return milestones.length > 0 ? (
		<div className={styles.timelineContainer}>
			<div className={styles.timeline}>
				{Object.keys(legislatures).map((legislature) => (
					<>
						<div key={legislature} className={styles.legislatureContainer}>
							{legislature?.length && (
								<div className={styles.legislatureBanner}>
									{legislature}
									<sup>ème</sup> législature
								</div>
							)}
							{legislatures[legislature].map((milestone, index) => (
								<TimelineMilestone
									key={`${milestone.acteLegislatif?.uid}-${index}`}
									milestone={milestone}
									selectedActeUid={selectedActeUid}
									onChangeActe={onChangeActe}
								/>
							))}
						</div>
					</>
				))}
			</div>
		</div>
	) : (
		<Loader />
	);
};
